import * as R from "remeda";

export function setupCommunication({me, them, expose}) {
    let promisesMap = new Map();
    let _uniqueId = R.randomInteger(1, 999999)*10000;

    function uniqueId() {
        return ++_uniqueId;
    }

    window.addEventListener('message', async function (event) {
        // Ensure the message is coming from your extension
        if (event?.data.source !== them) {
            return
        }
        if (event?.data.action) {
            if (!expose[event?.data.action]) {
                return
            }

            window.postMessage({
                source: me,
                messageId: event?.data.messageId,
                payload: await expose[event?.data.action](event?.data.payload).catch(error => ({ error })),
            }, '*');

        } else if (event?.data.messageId) {
            const error = event?.data?.payload?.error;
            if(!error) {
                promisesMap.get(event.data.messageId).resolve(event.data.payload);
            } else {
                promisesMap.get(event.data.messageId).reject(error);
            }

            promisesMap.delete(event.data.messageId)
        } else {
            console.log('wait...')
        }
    });


    return {
        sendMessage: (action, payload) => {
            // console.log(`${me}->${them} action: ${action}`)
            const messageId = uniqueId();
            // console.log('messageId', messageId)
            return new Promise((resolve, reject) => {
                promisesMap.set(messageId, {
                    resolve,
                    reject
                })
                window.postMessage({
                    source: me,
                    messageId: messageId,
                    action,
                    payload
                }, '*');
            })
        }
    }
}